import { useEffect, useState } from "react";
import useEventos from "../../../api/eventosApi";
import { Modal, MuniSpinner2, Table } from "../../../components";
import { useActaDetalleStore } from "../../../store/actaDetalleStore";
import { useEventosStore } from "../../../store/eventosStore";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import ModalDetalleEvento from "../ModalDetalleEvento";
import { eventosActasTableData } from "./tableData";

const ModalActaAuditar = () => {
  const { loads, modals, handlerModal } = useGeneralAppStore();
  const { eventosActa } = useEventosStore();
  const { actaDetalle } = useActaDetalleStore();
  const { auditActa, getEventSelect, getActaAudits } = useEventos();

  const [eventos, setEventos] = useState()

  useEffect(() => {
    // if (actaDetalle && actaDetalle.acta.id ) {
    getActaAudits({ subject_type: "totalAuditsActa", log_name: "user", numero_acta: actaDetalle.acta.numero_infraccion, setEventos })
    // auditActa({ subject_id: actaDetalle.acta.id });
    // }
  }, []);

  return (
    <>
      <Modal
        show={modals.includes("auditar_acta")}
        // fullscreen
        size={'xl'}
        onHide={() => handlerModal({ modal: false, modalName: "auditar_acta" })}
        title={() =>
          `Eventos del Acta ${actaDetalle.acta.dependencia}-${actaDetalle.acta.numero_infraccion}`
        }
      >
        {loads.includes("audits_totales") ? (
          <MuniSpinner2 />
        ) : (
          <>
            <div className="bg-white w-100">
              <section className="position-relative">
                {loads.includes("detalle-evento") && (
                  <div
                    className="d-flex justify-content-center align-items-center position-absolute w-100 h-100 z-2"
                    style={{ backgroundColor: "rgba(255,255,255,0.7)" }}
                  >
                    <MuniSpinner2 />
                  </div>
                )}
                {loads.includes("acta_detalle") && (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ backgroundColor: "rgba(255,255,255,0.7)" }}
                  >
                    <MuniSpinner2 />
                  </div>
                )}

                {eventos && (
                  <Table
                    loading={loads.includes("acta-auditar")}
                    data={eventosActasTableData(eventos, getEventSelect)}
                  // data={eventosActasTableData(eventosActa, getEventSelect)}
                  />
                )}
              </section>
            </div>
            {modals.includes("detalle-evento") && <ModalDetalleEvento />}
          </>
        )}
      </Modal>
    </>
  );
};
export default ModalActaAuditar;
